import PaintProcurementSummaryWorkspace from '../../placeholders/PaintProcurementSummaryWorkspace';

export default PaintProcurementSummaryWorkspace;
